import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import {
  getAllRestauranstsRequest,
  getUserOrganizationsRequest,
} from "../../services/getOrganizationAndRestaurant";
import { getToken } from "../../utils/utility";
import { notification } from "antd";

export function* getRestaurants() {
  try {
    const token = getToken().get("idToken");

    const response = yield call(getAllRestauranstsRequest, token);

    if (response[0] === 200) {
      if (response[1].length === 1) {
        localStorage.setItem("restaurantId", response[1][0].id);
      }

      yield put({
        type: actions.GET_RESTAURANTS_SUCCESS,
        restaurants: response[1],
      });
      if (response[1].length === 1) {
        yield put({
          type: actions.SET_SELECTED_RESTAURANT,
          restaurant: response[1][0].id,
        });
      }
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }

      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export function* getOrganizations() {
  try {
    const token = getToken().get("idToken");
    const response = yield call(getUserOrganizationsRequest, token);
    if (response[0] === 200) {
      if (
        localStorage.getItem("organizationId") !== undefined &&
        localStorage.getItem("organizationId") !== null &&
        !isNaN(parseInt(localStorage.getItem("organizationId")))
      ) {
        let org = response[1].filter(
          (x) => x.id === parseInt(localStorage.getItem("organizationId"))
        );
        if (org.length > 0) {
          localStorage.setItem("hotelEnabled", org[0]["hotelEnabled"]);
          localStorage.setItem("displayName", org[0]["displayNameBulgarian"]);
          localStorage.setItem("organization", org[0]["displayNameBulgarian"]);
          localStorage.setItem(
            "restaurantId",
            org[0]["defaultTouchSaleRestaurantId"]
          );
        }
      }
      yield put({
        type: actions.GET_USER_ORGANIZATIONS_SUCCESS,
        organizations: response[1],
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }

      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }

      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export default function* rootSaga() {
  yield all([
    yield takeEvery(actions.GET_RESTAURANTS_REQUEST, getRestaurants),
    yield takeEvery(actions.GET_USER_ORGANIZATIONS_REQUEST, getOrganizations),
  ]);
}
